import React from "react";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { resolveErrorMessage } from "../../utils/resolveErrorMessage";
import { DeleteInstalledBaseRegionSubscription } from "../../graphql/mutations/deleteInstalledBaseRegionSubscription";
import ConfirmDeleteModal from "../ConfirmDeleteModal";

interface Props {
    open: boolean;
    subscriptionId: string;
    regionName?: string;
    onClose: () => void;
}

const DeleteRegionSubscriptionModal = ({ open, subscriptionId, regionName, onClose }: Props) => {
    const { t } = useTranslation();

    const [deleteSubscription, { loading }] = useMutation(DeleteInstalledBaseRegionSubscription, {
        refetchQueries: ["InstalledBaseRegionSubscriptions"],
    });

    const handleConfirm = () => {
        deleteSubscription({ variables: { id: subscriptionId } })
            .then((res) => {
                if (res.data?.deleteInstalledBaseRegionSubscription?.success === false) {
                    toast.error(
                        res.data.deleteInstalledBaseRegionSubscription.message || t("Failed to delete subscription.")
                    );
                    return;
                }
                toast.success(
                    regionName ? t('Removed subscription for "{{title}}".', { title: regionName }) : t("Subscription removed.")
                );
                onClose();
            })
            .catch((err) => toast.error(resolveErrorMessage(err, t)));
    };

    return (
        <ConfirmDeleteModal
            open={open}
            loading={loading}
            onConfirm={handleConfirm}
            onClose={onClose}
            title={t("Delete subscription")}
            message={
                regionName
                    ? t(
                          "Are you sure you want to permanently delete the subscription for {{name}}? This action cannot be undone.",
                          { name: regionName }
                      )
                    : t("Are you sure you want to permanently delete this subscription? This action cannot be undone.")
            }
        />
    );
};

export default DeleteRegionSubscriptionModal;
